import { ViewHook } from 'phoenix_live_view';

type EnterOnFocusHook = Partial<ViewHook> & {
  el: HTMLElement;

  onFocusInCallback: () => void;
  onFocusOutCallback: () => void;
  onEnterOnFocusCallback: (e: KeyboardEvent) => void;

  addEventListeners: () => void;
  removeEventListeners: () => void;

  addFocusInListener: () => void;
  removeFocusInListener: () => void;

  addFocusOutListener: () => void;
  removeFocusOutListener: () => void;

  addEnterOnFocusListener: () => void;
  removeEnterOnFocusListener: () => void;

  onFocusIn: () => void;
  onFocusOut: () => void;
  onEnterOnFocus: (e: KeyboardEvent) => void;
};

export default {
  EnterOnFocus: {
    mounted() {
      this.onFocusInCallback = this.onFocusIn.bind(this);
      this.onFocusOutCallback = this.onFocusOut.bind(this);
      this.onEnterOnFocusCallback = this.onEnterOnFocus.bind(this);

      this.addEventListeners();
    },

    destroyed() {
      this.removeEventListeners();
    },

    addEventListeners() {
      this.addFocusInListener();
    },

    removeEventListeners() {
      this.removeFocusInListener();
      this.removeFocusOutListener();
    },

    addFocusInListener() {
      this.el.addEventListener('focus', this.onFocusInCallback);
    },

    removeFocusInListener() {
      this.el.removeEventListener('focus', this.onFocusInCallback);
    },

    addFocusOutListener() {
      this.el.addEventListener('focusout', this.onFocusOutCallback);
    },

    removeFocusOutListener() {
      this.el.removeEventListener('focusout', this.onFocusOutCallback);
    },

    onFocusIn() {
      this.removeFocusInListener();
      this.addEnterOnFocusListener();
      this.addFocusOutListener();
    },

    onFocusOut() {
      this.removeFocusOutListener();
      this.removeEnterOnFocusListener();
      this.addFocusInListener();
    },

    addEnterOnFocusListener() {
      this.el.addEventListener('keydown', this.onEnterOnFocusCallback);
    },

    removeEnterOnFocusListener() {
      this.el.removeEventListener('keydown', this.onEnterOnFocusCallback);
    },

    onEnterOnFocus(e: KeyboardEvent) {
      if (e.key == 'Enter' && e.shiftKey == false) {
        this.el.click();
      }
    },
  } as EnterOnFocusHook,
};
